import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateStoreApi } from "../../services/store/update.store.api";

export const useUpdateStoreApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (infoUpdate: any) => updateStoreApi(infoUpdate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["all-store"],
        exact: false,
      });
    },
  });
};
